export const formatDate = (myDate, myTime) => {
    let date = new Date(myDate + "T" + myTime);
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes() < 10 ? "0" : ""}${date.getMinutes()} `;
};
